<template>
  <v-container fluid class="ma-0 pa-0 route-view-card fill-height">
    <v-progress-linear indeterminate color="#00A5A2" />
  </v-container>
</template>

<script>
export default {
  name: "LoadingState"
}
</script>

<style scoped>
.route-view-card {
  background-color: #F2F5F3;
}
</style>